import { render } from "./BienImmobilierVenteView.vue?vue&type=template&id=2518f3b6&scoped=true"
import script from "./BienImmobilierVenteView.vue?vue&type=script&lang=js"
export * from "./BienImmobilierVenteView.vue?vue&type=script&lang=js"

import "./BienImmobilierVenteView.vue?vue&type=style&index=0&id=2518f3b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2518f3b6"]])

export default __exports__